<template>
  <div class="tablist_w">
    <div class="title">
      <div class="tab_lf">
        <span class="red-icon"></span>
        <span>{{title}}</span>
      </div>
      <div class="tab_ri" v-show="showbtn">
        <router-link tag="span" class="red_s" :to="'/hall'">我要买</router-link>
        <router-link tag="span" :to="'/sellpage'">我要卖</router-link>
      </div>
    </div>
    <p class="head border-1px">
      <span @click.stop="handlePaixu('account')">会员账号<i class="icon paixu"  v-show="codeshow!==4"></i></span>
      <span @click.stop="handlePaixu('e_level')" class="flexLong">等级<i class="icon paixu" v-show="codeshow!==4"></i></span>
      <span @click.stop="handlePaixu('sale_price')">标价<i class="icon paixu"  v-show="codeshow!==4"></i></span>
      <span v-show="codeshow!==4">详细资料</span>
      <span v-show="codeshow!==4">操作</span>
      <span  v-show="codeshow==4">状态</span>
    </p>
    <section class="tab_l_w">
      <ul class="tab_ul clearfix">
        <li class="tab_li border-1px" v-for="item in list" :key="item.id">
          <span class="account"><i v-show="item.hot==1"></i>{{item.account}}</span>
          <span class="green_w" v-if="sale_extend == 1">电子: {{item.e_level}}&nbsp;真人: {{item.r_level}}</span>
          <span class="green_w" v-else>LV.{{item.e_level}}</span>
          <span>￥{{Number(item.sale_price)}}</span>
          <span v-show="codeshow!==4"><span class="btn_ww" @click="gotoDetail(item.id)">详细资料</span></span>
          <span v-show="codeshow!==4"><span class="btn_ww" @click.stop="handleBuy(item)">立即购买</span></span>
          <span v-show="codeshow==4"><span class="red_w">交易成功</span></span>
        </li>
      </ul>
    </section>
    <div class="tab_bot">
      <div class="bot_top">
        <div class="num_w">共{{total_count}}条记录</div>
        <div class="ye_w">每页显示：
          <span class="tab_box" :class="{on:showtb==20}" @click="handleTB(20)">20</span>
          <span class="tab_box" :class="{on:showtb==50}" @click="handleTB(50)">50</span>
          <span class="tab_box" :class="{on:showtb==100}" @click="handleTB(100)">100</span>
          <span class="tab_box" :class="{on:showtb==200}" @click="handleTB(200)">200</span>
        </div>
      </div>
      <div class="bot_bottom" v-if="total_page">
        <span class="pre_s" @click="preNum(1)">上一页</span>
        <template v-if="showOne">
          <span class="first_s" v-for="(num,index) in total_page" :class="{showlh:showLH==index+1}" @click="handleList(index)">{{num}}</span>
        </template>
        <template v-else>
          <span class="first_s" :class="{showlh:showLH==1}" @click="handleNum(1)">1</span>
          <span class="first_s" v-show="!ShowLeft" :class="{showlh:showLH==2}" @click="handleNum(2)">2</span>
          <span class="dian_s" v-show="ShowLeft" @click="preNum(3)">...</span>
          <span class="first_s" v-for="(num,index) in arr" :key="index" v-show="index+1<lineHS+2&&index+1>lineHS-2" @click="handleNum(num)" :class="{showlh:showLH==index+1}">{{num}}</span>
          <span class="dian_s" v-show="ShowRight" @click="nextNum(3)">...</span>
          <span class="first_s" v-show="!ShowRight" :class="{showlh:showLH==total_page-1}" @click="handleNum(total_page-1)">{{total_page-1}}</span>
          <span class="last_s" :class="{showlh:showLH==total_page}" @click="handleNum(total_page)">{{total_page}}</span>
        </template>
        <span class="next_s" @click="nextNum(1)">下一页</span>
      </div>
    </div>
    <div class="bar"></div>
  </div>
</template>

<script>
  import { saleResource } from '@/resource/resource'
  const ERR_OK = 0
  export default {
    name: 'tablist',
    props: ['title', 'showbtn', 'hotshow', 'overtype', 'codeshow', 'detailshow'],
    data () {
      return {
        list: [],
        total_count: 0,
        total_page: '',
        condition: {
          count: 11,
          page: 0,
          type: 1
        },
        showtb: 0,
        arr: [],
        showOne: false,
        // ShowLeft: false,
        // ShowRight: true,
        lineHS: 4,
        showLH: 1,
        upShow: true,
        sale_extend: ''
      }
    },
    computed: {
      ShowLeft() {
        let tt = false
        if (this.showLH > 4) {
          tt = true
        }
        return tt
      },
      ShowRight() {
        let tt = true
        if (this.showLH > (this.total_page - 4)) {
          tt = false
        }
        return tt
      }
    },
    created () {
      this.sale_extend = localStorage.getItem('sale_extend')
      if (this.hotshow) {
        this.condition.hot = 1
      }
      if (this.overtype) {
        this.condition.type = 2
      }
      if (!this.isObj(this.$route.query)) {
        this.s_params = {}
        this.init()
      } else {
        this.getList(this.condition)
      }
    },
    mounted () {
    },
    methods: {
      handleTB (num) {
        this.showtb = num
        let obj = {}
        if (!this.isObj(this.$route.query)) {
          this.s_params.count = num
          this.s_params.page = 0
          obj = this.s_params
        } else {
          this.condition.count = num
          this.condition.page = 0
          obj = this.condition
        }
        this.getList(obj)
      },
      init() {
        Object.assign(this.s_params, this.$route.query)
        this.s_params.page = 0
        this.s_params.count = this.condition.count
        if (this.hotshow) {
          this.s_params.hot = 1
        }
        if (this.overtype) {
          this.s_params.type = 2
        } else {
          this.s_params.type = 1
        }
        this.getList(this.s_params)
      },
      getList (condition) {
        saleResource.list(condition).then(response => {
          response = response.body
          if (response.errcode === ERR_OK) {
            if (response.data) {
              this.list = response.data
              for (var i = 0; i < this.list.length; i++) {
                this.list[i].sale_price = Number(this.list[i].sale_price)
              }
              this.total_count = response.page.total_count
              this.total_page = response.page.total_page
              this.getArr(this.total_page)
              if (Number(this.total_page) < 8) {
                this.showOne = true
              }
            }
          }
        })
      },
      getArr (num) {
        this.arr = []
        for (var i = 1; i < (Number(num) + 1); i++) {
          this.arr.push(i)
        }
        return this.arr
      },
      handleList (index) {
        if (this.showLH === (index + 1)) {
          return
        }
        this.showLH = index + 1
        let obj = {}
        if (!this.isObj(this.$route.query)) {
          this.s_params.page = index
          obj = this.s_params
        } else {
          this.condition.page = index
          obj = this.condition
        }
        this.getList(obj)
      },
      handleGetList () {
        let obj = {}
        if (!this.isObj(this.$route.query)) {
          this.s_params.page = this.showLH - 1
          obj = this.s_params
        } else {
          this.condition.page = this.showLH - 1
          obj = this.condition
        }
        this.getList(obj)
      },
      handleNum (num) {
        if (this.showLH === num) {
          return
        }
        this.showLH = num
        if (num > 3 && num < (this.total_page - 2)) {
          this.lineHS = num
        } else if (num <= 3) {
          this.lineHS = 4
        } else if (num >= (this.total_page - 2)) {
          this.lineHS = this.total_page - 3
        }
        this.handleGetList()
      },
      preNum (n) {
        if (this.showLH > 1) {
          for (var i = 0; i < n; i++) {
            this.showLH--
          }
        } else {
          return
        }
        if (this.showLH > 3 && this.showLH < (this.total_page - 2)) {
          this.lineHS = this.showLH
        } else if (this.showLH <= 3) {
          this.lineHS = 4
        } else if (this.showLH >= (this.total_page - 2)) {
          this.lineHS = this.total_page - 3
        }
        this.handleGetList()
      },
      nextNum (n) {
        if (this.showLH < this.total_page) {
          for (var i = 0; i < n; i++) {
            this.showLH++
          }
        } else {
          return
        }
        if (this.showLH > 3 && this.showLH < (this.total_page - 2)) {
          this.lineHS = this.showLH
        } else if (this.showLH <= 3) {
          this.lineHS = 4
        } else if (this.showLH >= (this.total_page - 2)) {
          this.lineHS = this.total_page - 3
        }
        this.handleGetList()
      },
      handlePaixu (pname) {
        if (this.upShow) {
          this.list.sort(this.compareUp(pname))
          this.upShow = !this.upShow
        } else {
          this.list.sort(this.compareDown(pname))
          this.upShow = !this.upShow
        }
      },
      // data.sort(compareUp("age"))
      // data.sort(compareDown("age"))
      compareUp(propertyName) { // 升序排序
        if ((typeof this.list[0][propertyName]) !== 'number') { // 属性值为非数字
          return function(object1, object2) {
            var value1 = object1[propertyName]
            var value2 = object2[propertyName]
            return value1.localeCompare(value2)
          }
        } else {
          return function(object1, object2) { // 属性值为数字
            var value1 = object1[propertyName]
            var value2 = object2[propertyName]
            return value1 - value2
          }
        }
      },
      compareDown(propertyName) { // 降序排序
        if ((typeof this.list[0][propertyName]) !== 'number') { // 属性值为非数字
          return function(object1, object2) {
            var value1 = object1[propertyName]
            var value2 = object2[propertyName]
            return value2.localeCompare(value1)
          }
        } else {
          return function(object1, object2) { // 属性值为数字
            var value1 = object1[propertyName]
            var value2 = object2[propertyName]
            return value2 - value1
          }
        }
      },
      isObj (obj) {
        var b = (JSON.stringify(obj) === '{}')
        return b
      },
      gotoDetail (id) {
        if (this.detailshow) {
          this.$router.push('/hall/' + id)
        } else {
          this.$router.push('/rehall/' + id)
        }
      },
      handleBuy (data) {
         this.$emit('funBuy', data, 1)
      }
    },
    watch: {
      '$route.query' (val, oldVal) {
        if (val !== oldVal) {
          this.s_params = {}
          this.init()
        }
      }
    },
    components: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "~@/common/stylus/mixin.styl"
  .tablist_w
    margin-top 0.2rem
    .bar
      height 0.2rem
      width 100%
    .title
      height 0.8rem
      line-height @height
      font-size $fz-t3
      color $c-b1
      width 100%
      background-color #fff
      display flex
      justify-content space-between
      .tab_lf
        display flex
        align-items center
        .red-icon
          display inline-block
          width 0.06rem
          height 0.32rem
          margin 0 0.20rem 0 0.28rem
          background-color $blue
          border-radius 0.02rem
      .tab_ri
        padding-right 0.28rem
        & > span
          font-size $fz-t1
          display inline-block
          height 0.48rem
          width 1.2rem
          text-align center
          line-height 0.48rem
          border-radius 0.24rem
          color #fff
          background-color #f99a24
        .red_s
          background-color #cd3c29
          margin-right 0.26rem
    .head
      background-color #eeeeee
      font-size $fz-t2
      color $c-b1
      display flex
      height 0.6rem
      line-height @height
      // border-1px(#f4f4f4)
      // border-left-none()
      & > span
        flex 1
        text-align center
        border-right 0.02rem solid #f4f4f4
        box-sizing border-box
        &.flexLong
          flex 1.5
        &:last-child
          border-right none
        .icon
          display inline-block
          width 0.16rem
          height 0.2rem
          background-size cover
          &.paixu
            margin-left 0.08rem
            bg-image('paixu')
    .tab_l_w
      min-height 3rem
      overflow hidden
      background-color #fff
      .tab_ul
        width 100%
        // height 6.3rem
        .tab_li
          height 0.6rem
          line-height @height
          // padding 0.3rem 0
          border-bottom 1px solid #f4f4f4
          box-sizing border-box
          color $c-b1
          font-size $fz-t1
          display flex
          align-items center
          position relative
          & > span
            flex 1
            text-align center
            border-right 0.02rem solid #f4f4f4
            & > last-child
              border-right none
            &.account
              width 1rem
              word-break break-all
              i
                position absolute
                top 0
                left 0
                display inline-block
                bg-image('hot')
                height 0.44rem
                width 0.44rem
                background-size cover
                background-repeat no-repeat
            .btn_ww
              display inline-block
              width 1.2rem
              height 0.4rem
              line-height 0.4rem
              text-align center
              background-color $blue
              color #fff
              border-radius 0.1rem
            .red_w
              color #cd3c29
          .green_w
            color #167e5d
            flex 1.5
          .red_w
            color #cd3c29
    .tab_bot
      margin-top 0.2rem
      font-size $fz-t1
      color $c-b1
      background-color #fff
      .bot_top
        display flex
        align-items center
        height 0.8rem
        padding 0 0.12rem 0 0.28rem
        .ye_w
          flex 1
          text-align right
          .tab_box
            display inline-block
            height 0.5rem
            width 0.5rem
            text-align center
            line-height 0.5rem
            border 1px solid #cccccc
            box-sizing border-box
            margin-right 0.16rem
            &.on
              background-color $blue
              color #fff
              border 1px solid $blue
      .bot_bottom
        height 0.8rem
        padding-left 0.28rem
        color $c-b1
        display flex
        align-items center
        & > span
          display inline-block
          height 0.5rem
          width 0.5rem
          text-align center
          line-height 0.5rem
          border 1px solid #cccccc
          box-sizing border-box
          margin-right 0.1rem
          &.showlh
            background-color $blue
            color #fff
        .pre_s, .next_s
          width 1.2rem
        .dian_s
          font-size 0.28rem
          font-weight 700
          line-height 0.35rem
</style>



// WEBPACK FOOTER //
// src/components/common/tablist/tablist.vue